import PageHeading from '../../shared/components/UIElements/PageHeading';
import React, { useEffect, useState } from 'react';
import Card from '../../shared/components/UIElements/Card';
import './PharmacyInsight.css';

const PharmacyInventoryDashboard = () => {
  const [inventory, setInventory] = useState([]);
  const [analysis, setAnalysis] = useState({});
  const [alerts, setAlerts] = useState([]);

  // Simulate data loading
  useEffect(() => {
    const dummyInventory = [
      { name: 'Paracetamol 500mg', quantity: 200, threshold: 50 },
      { name: 'Amoxicillin 250mg', quantity: 30, threshold: 40 },
      { name: 'Ibuprofen 400mg', quantity: 100, threshold: 30 },
      { name: 'Cetirizine 10mg', quantity: 15, threshold: 25 }
    ];

    const dummyAnalysis = {
      mostSold: 'Paracetamol 500mg',
      leastStock: 'Cetirizine 10mg',
      predictedOutOfStock: ['Amoxicillin 250mg', 'Cetirizine 10mg'],
      restockSuggestion: ['Cetirizine 10mg', 'Amoxicillin 250mg']
    };

    const dummyAlerts = [
      'Amoxicillin 250mg is below threshold!',
      'Cetirizine 10mg needs urgent restock!'
    ];

    setInventory(dummyInventory);
    setAnalysis(dummyAnalysis);
    setAlerts(dummyAlerts);
  }, []);

  return (
    <div className="inventory-dashboard">
      <PageHeading
        eyebrow="PHARMACY OPERATIONS"
        title="Inventory insights"
        description="Review stock levels and plan your next restock."
      />
      <p className="sample-data-note">
        Sample inventory · This overview currently uses demonstration data.
      </p>
      <Card className="inventory-card">
        <div className="panel-heading">
          <h2>Stock overview</h2>
          <span className="badge">{inventory.length} medications</span>
        </div>
        <div className="table-scroll">
          <table>
            <thead>
              <tr>
                <th>Drug Name</th>
                <th>Quantity</th>
                <th>Threshold</th>
                <th>Status</th>
              </tr>
            </thead>
            <tbody>
              {inventory.map((item, idx) => (
                <tr key={idx} className={item.quantity < item.threshold ? 'low-stock' : ''}>
                  <td>{item.name}</td>
                  <td>{item.quantity}</td>
                  <td>{item.threshold}</td>
                  <td>{item.quantity < item.threshold ? 'Low Stock' : 'OK'}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        <h3>Stock alerts</h3>
        <ul>
          {alerts.map((alert, idx) => (
            <li key={idx} className="alert-item">
              {alert}
            </li>
          ))}
        </ul>

        <h3>Analysis & predictions</h3>
        <p>
          <strong>Most Sold:</strong> {analysis.mostSold}
        </p>
        <p>
          <strong>Least Stock:</strong> {analysis.leastStock}
        </p>
        <p>
          <strong>Predicted Out of Stock:</strong> {analysis.predictedOutOfStock?.join(', ')}
        </p>
        <p>
          <strong>Restock Suggestion:</strong> {analysis.restockSuggestion?.join(', ')}
        </p>
      </Card>
    </div>
  );
};

export default PharmacyInventoryDashboard;
